module.exports = __webpack_public_path__ + "static/1.12cdf1f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DBD/1.png
// module id = 752
// module chunks = 168707334958949